<template>
  <CodeVerification
    :description="t(useTranslationPath(callerPath, 'description'))"
    :site-id="authStore.maintainableEntity.id"
    :is-loading
    :action-label="useTranslationPath(callerPath, 'continue')"
    @valid="handleCheckOut"
  />
</template>

<script setup>
import CodeVerification from '@/components/Verification/CodeVerification.vue'
import { useGoBack } from '@/composables/useGoBack.js'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { isAccessCodeEnabled } from '@/composables/useVerificationMethod.js'
import { useAppStore } from '@/stores/AppStore.js'
import { useAuthStore } from '@/stores/authenticated/AuthStore'
import { useEngineerStore } from '@/stores/authenticated/EngineerStore.js'
import { useWorkOrderStore } from '@/stores/authenticated/WorkOrderStore.js'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'

const { t } = useI18n()

const route = useRoute()
const router = useRouter()
const { setCustomGoBack } = useGoBack()

const appStore = useAppStore()
const authStore = useAuthStore()
const engineerStore = useEngineerStore()
const workOrderStore = useWorkOrderStore()

const callerPath = 'views.authenticated.workOrders.checkout.verification.code'

const isLoading = ref(false)

onMounted(async () => {
  setCustomGoBack(() =>
    router.push({
      name: `work-order.detail`,
      params: {
        workOrderId: workOrderStore.workOrder.id,
      },
    }),
  )

  engineerStore.$patch({
    verificationData: {
      checkIn: engineerStore.verificationData.checkIn,
      checkOut: { method: null, data: null },
    },
  })

  appStore.$patch({ showBackButton: true })

  if (!isAccessCodeEnabled('ENGINEER_APP_CHECK_OUT_METHOD')) {
    await router.push({
      name: 'work-order.checkout.index',
      params: { workOrderId: route.params.workOrderId },
    })
  }
})

const handleCheckOut = async (verified = true) => {
  isLoading.value = true

  if (verified) {
    engineerStore.$patch({
      verificationData: {
        checkIn: engineerStore.verificationData.checkIn,
        checkOut: {
          method: 'ACCESS_CODE',
          data: null,
        },
      },
    })

    await router.push({
      name: 'work-order.checkout.index',
      params: { workOrderId: route.params.workOrderId },
    })
  }

  isLoading.value = false
}
</script>
